import { Fragment, type ReactNode } from 'react';
import { parseWhatsAppMarkup, type MarkupNode } from '@/lib/whatsappMarkup';

type Props = {
  text: string;
};

function renderNodes(nodes: MarkupNode[]): ReactNode[] {
  return nodes.map((node, i) => {
    if (node.type === 'text') {
      return <Fragment key={i}>{node.value}</Fragment>;
    }

    const children = renderNodes(node.children);

    switch (node.type) {
      case 'bold':
        return (
          <strong key={i} className="font-semibold">
            {children}
          </strong>
        );
      case 'italic':
        return <em key={i}>{children}</em>;
      case 'strike':
        return <s key={i}>{children}</s>;
      case 'mono':
        return (
          <code key={i} className="rounded bg-black/10 px-1 font-mono text-[0.9em]">
            {children}
          </code>
        );
      default:
        return null;
    }
  });
}

/**
 * Rendert WhatsApp-Nachrichtentext mit der Auszeichnung, die der Kunde im Chat sieht
 * (`*fett*`, `_kursiv_`, `~durchgestrichen~`, monospace). Nur echte React-Elemente,
 * kein HTML aus Nachrichteninhalten.
 */
export function WhatsAppText({ text }: Props) {
  return <>{renderNodes(parseWhatsAppMarkup(text))}</>;
}

export default WhatsAppText;
